import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CompetitionWinnersRequest } from 'src/app/model/api/api-request/competition-winners-request';
import { CompetitionSignUpRequest } from 'src/app/+competitions/model/api/competition-signup-request';
import { ApiClient } from '../../../infrastructure/api-client/api-client';
import { SimpleCompetitor } from 'src/app/+shared/model/interfaces/simple-competitor';
import { Competition } from 'src/app/+competitions/model/interfaces/competition';
import { CompetitionPrizesRequest } from 'src/app/model/api/api-request/competition-prizes-request';
import { CompetitionWinner } from '../../model/interfaces/competition-winner';
import { CompetitionPrize } from '../../model/interfaces/competition-prize';
import { allCompentions } from './competitionsData';
import { DOCUMENT } from '@angular/common';
import { AppConfigService } from 'src/app/services/app-config.service';
declare var ddkCompetitions;

@Injectable()
export class CompetitionRepository
{
    private readonly apiClient: ApiClient;
    private competitionsArray: Competition[];
    
    private window: Window;

    public constructor(apiClient: ApiClient, @Inject(DOCUMENT) private document: Document, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
        this.window = this.document.defaultView;
    }

    public getCompetitions(): Observable<Competition[]>
    {
        if(this.window["ddkCompetitions"] != null){
            this.competitionsArray = this.window["ddkCompetitions"];

            this.competitionsArray.forEach((item, index) => {
                 item.ActiveFrom = new Date(item.ActiveFrom);
                 item.ActiveTo = new Date(item.ActiveTo);   
                 item.WinnersPublishDate = new Date(item.WinnersPublishDate);   
                 item.Id = parseInt(this.window["ddkCompetitions"][index].CompetitionId) ; 
                 item.Type = parseInt(this.window["ddkCompetitions"][index].Type)

                 item.ExternalCompetitionUrl = this.window["ddkCompetitions"][index].ExternalLink == null ? "" :  this.window["ddkCompetitions"][index].ExternalLink.Url; 

                 item.Images = {
                    DefaultUrl: this.window["ddkCompetitions"][index].DefaultImage == null ? "" :  this.window["ddkCompetitions"][index].DefaultImage.Src, 
                    ListCardUrl: this.window["ddkCompetitions"][index].ListImage == null ? "" :  this.window["ddkCompetitions"][index].ListImage['Src'], 
                    HeroUrl: this.window["ddkCompetitions"][index].HeroImage == null ? "" :  this.window["ddkCompetitions"][index].HeroImage.Src
                 }
            });


        }else{
            this.competitionsArray = [];
        }


        var d = new Date();
            d.setMonth(d.getMonth() - 3);
        const threeMonhsAgoMillis = d.getTime();
        const activeCompetitions = this.competitionsArray.filter(item =>
            {
                const publishDateMillis = new Date(item.WinnersPublishDate).getTime();

                return (threeMonhsAgoMillis < publishDateMillis);
            });

        return of(activeCompetitions);
    }

    public signUpToCompetition(competitor: SimpleCompetitor): Observable<any>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new CompetitionSignUpRequest(competitor, webapiBasepath);
        return this.apiClient.post(request);
    }

    public getWinnersByCompetitionId(competitionId: number): Observable<CompetitionWinner[]>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new CompetitionWinnersRequest(competitionId, webapiBasepath);
        return this.apiClient.get(request);
    }

    public getPrizesByCompetitionId(competitionId: number): Observable<CompetitionPrize[]>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new CompetitionPrizesRequest(competitionId, webapiBasepath) ;
        return this.apiClient.get(request);
    }
}
